import { apiGetOneOrNull, apiPatch } from '@/core/api/resources'
import { DEFAULT_AMPEL_SCHWELLEN, isValidSchwellen, type AmpelSchwellen } from '@/core/lib/ampel'
import { trackSettingsWrite } from '@/core/api/settingsWrites'

type AmpelColumns = { ampel_gelb_tage?: number | null; ampel_rot_tage?: number | null }

export function schwellenFromRow(row: AmpelColumns | null): AmpelSchwellen {
  const gelbTage = row?.ampel_gelb_tage
  const rotTage = row?.ampel_rot_tage
  if (typeof gelbTage !== 'number' || typeof rotTage !== 'number') return DEFAULT_AMPEL_SCHWELLEN
  const s = { gelbTage, rotTage }
  return isValidSchwellen(s) ? s : DEFAULT_AMPEL_SCHWELLEN
}

export async function getAmpelSchwellen(organisationId: string): Promise<AmpelSchwellen> {
  const row = await apiGetOneOrNull('/organisation/{id}', { id: organisationId })
  const s = schwellenFromRow(row)
  remember(organisationId, s)
  return s
}

export function updateAmpelSchwellen(organisationId: string, s: AmpelSchwellen): Promise<void> {
  return trackSettingsWrite(async (identity) => {
    await apiPatch('/organisation/{id}', { id: organisationId }, { ampel_gelb_tage: s.gelbTage, ampel_rot_tage: s.rotTage }, identity)
    remember(organisationId, s)
  })
}

const cache = new Map<string, AmpelSchwellen>()
const listeners = new Set<() => void>()

function remember(organisationId: string, s: AmpelSchwellen): void {
  cache.set(organisationId, s)
  for (const listener of listeners) listener()
}

export function cachedAmpelSchwellen(organisationId: string): AmpelSchwellen | undefined {
  return cache.get(organisationId)
}

export function subscribeAmpelSchwellen(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
